import {
   userStart,
   userFailure,
   loginSuccess,
   loginFailure,
   logoutSuccess,
   getUserSuccess,
   deleteUserSuccess,
   updateUserSuccess,
   createUserSuccess,
} from "./userRedux"
import {
   productStart,
   productFailure,
   getProductsSuccess,
   deleteProductSuccess,
   updateProductSuccess,
   createProductSuccess,
} from "./productRedux"
import {
   orderStart,
   orderFailure,
   getOrderSuccess,
   deleteOrderSuccess,
   updateOrderSuccess,
} from "./orderRedux"
import {
   shopStart,
   shopFailure,
   getShopsSuccess,
   deleteShopSuccess,
   updateShopSuccess,
   createShopSuccess,
} from "./shopRedux"
import {
   pageContentStart,
   pageContentFailure,
   getPageContentsSuccess,
   updatePageContentSuccess,
   createPageContentSuccess,
   deletePageContentSuccess,
} from "./pageContentRedux"
import {
   imageStart,
   imageFailure,
   getImageSuccess,
   updateImageSuccess,
   createImageSuccess,
   deleteImageSuccess,
} from "./imageRedux"
import {
   emailStart,
   emailFailure,
   getEmailSuccess,
   deleteEmailSuccess,
} from "./emailRedux"
import {
   serviceStart,
   serviceFailure,
   getServiceSuccess,
   updateServiceSuccess,
   deleteServiceSuccess,
   createServiceSuccess,
} from "./serviceRequestRedux"
import { publicRequest, userRequest } from "../requestMethods"

export const login = async (dispatch, user) => {
   dispatch(userStart())
   try {
      const res = await publicRequest.post("/auth/login", user)
      dispatch(loginSuccess(res.data))
   } catch (err) {
      const data = err?.response?.data
      const xhrText = err?.response?.request?.responseText
      let msg = null
      if (typeof data === "string") {
         msg = data
      } else if (data && typeof data === "object") {
         msg = data.message || data.error || data.msg || data.reason || null
         if (!msg) {
            try {
               msg = JSON.stringify(data)
            } catch {
               msg = String(data)
            }
         }
      }
      if (!msg && typeof xhrText === "string" && xhrText.trim().length) {
         msg = xhrText
      }
      if (!msg) {
         msg = err?.message || "Login failed"
      }
      dispatch(loginFailure(msg))
      return
   }
}

export const logout = async (dispatch) => {
   dispatch(userStart())
   try {
      dispatch(logoutSuccess())
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(loginFailure(msg))
      })()
   }
}

export const getUsers = async (dispatch) => {
   dispatch(userStart())
   try {
      const res = await userRequest.get("/users")
      dispatch(getUserSuccess(res.data))
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(userFailure(msg))
      })()
   }
}

export const deleteUser = async (id, dispatch) => {
   dispatch(userStart())
   try {
      await userRequest.delete(`/users/${id}`)
      dispatch(deleteUserSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(userFailure(msg))
         return msg
      })()
   }
}

export const updateUser = async (id, user, dispatch) => {
   dispatch(userStart())
   try {
      await userRequest.put(`/users/${id}`, user)
      dispatch(updateUserSuccess({ id, user }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(userFailure(msg))
         return msg
      })()
   }
}

export const createUser = async (user, dispatch) => {
   dispatch(userStart())
   try {
      const res = await publicRequest.post("/auth/register", user)
      dispatch(createUserSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(userFailure(msg))
         return msg
      })()
   }
}

export const getProducts = async (dispatch) => {
   dispatch(productStart())
   try {
      const res = await publicRequest.get("/products")
      dispatch(getProductsSuccess(res.data))
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(productFailure(msg))
      })()
   }
}

export const deleteProduct = async (id, dispatch) => {
   dispatch(productStart())
   try {
      await userRequest.delete(`/products/${id}`)
      dispatch(deleteProductSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(productFailure(msg))
         return msg
      })()
   }
}

export const updateProduct = async (id, product, dispatch) => {
   dispatch(productStart())
   try {
      await userRequest.put(`/products/${id}`, product)
      dispatch(updateProductSuccess({ id, product }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(productFailure(msg))
         return msg
      })()
   }
}

export const createProduct = async (product, dispatch) => {
   dispatch(productStart())
   try {
      const res = await userRequest.post(`/products`, product)
      dispatch(createProductSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(productFailure(msg))
         return msg
      })()
   }
}

export const getOrders = async (dispatch) => {
   dispatch(orderStart())
   try {
      const res = await userRequest.get("/orders")
      dispatch(getOrderSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(orderFailure(msg))
         return msg
      })()
   }
}

export const updateOrder = async (id, order, dispatch) => {
   dispatch(orderStart())
   try {
      await userRequest.put(`/orders/${id}`, order)
      dispatch(updateOrderSuccess({ id, order }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(orderFailure(msg))
         return msg
      })()
   }
}

export const deleteOrder = async (id, dispatch) => {
   dispatch(orderStart())
   try {
      await userRequest.delete(`/orders/${id}`)
      dispatch(deleteOrderSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(orderFailure(msg))
         return msg
      })()
   }
}

export const getShops = async (dispatch) => {
   dispatch(shopStart())
   try {
      const res = await publicRequest.get("/shops")
      dispatch(getShopsSuccess(res.data))
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(shopFailure(msg))
      })()
   }
}

export const deleteShop = async (id, dispatch) => {
   dispatch(productStart())
   try {
      await userRequest.delete(`/shops/${id}`)
      dispatch(deleteShopSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(shopFailure(msg))
         return msg
      })()
   }
}

export const updateShop = async (id, shop, dispatch) => {
   dispatch(shopStart())
   try {
      await userRequest.put(`/shops/${id}`, shop)
      dispatch(updateShopSuccess({ id, shop }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(shopFailure(msg))
         return msg
      })()
   }
}

export const createShop = async (shop, dispatch) => {
   dispatch(shopStart())
   try {
      const res = await userRequest.post(`/shops`, shop)
      dispatch(createShopSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(shopFailure(msg))
         return msg
      })()
   }
}

export const getPageContents = async (dispatch) => {
   dispatch(pageContentStart())
   try {
      const res = await publicRequest.get("/page-contents")
      dispatch(getPageContentsSuccess(res.data))
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(pageContentFailure(msg))
      })()
   }
}

export const deletePageContent = async (id, dispatch) => {
   dispatch(pageContentStart())
   try {
      await userRequest.delete(`/page-contents/${id}`)
      dispatch(deletePageContentSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(pageContentFailure(msg))
         return msg
      })()
   }
}

export const updatePageContent = async (id, pageContent, dispatch) => {
   dispatch(pageContentStart())
   try {
      await userRequest.put(`/page-contents/${id}`, pageContent)
      dispatch(updatePageContentSuccess({ id, pageContent }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(pageContentFailure(msg))
         return msg
      })()
   }
}

export const createPageContent = async (pageContent, dispatch) => {
   dispatch(pageContentStart())
   try {
      const res = await userRequest.post(`/page-contents`, pageContent)
      dispatch(createPageContentSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(pageContentFailure(msg))
         return msg
      })()
   }
}

export const getImages = async (dispatch) => {
   dispatch(imageStart())
   try {
      const res = await publicRequest.get("/images")
      dispatch(getImageSuccess(res.data))
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(imageFailure(msg))
      })()
   }
}

export const deleteImage = async (id, dispatch) => {
   dispatch(imageStart())
   try {
      await userRequest.delete(`/images/${id}`)
      dispatch(deleteImageSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(imageFailure(msg))
         return msg
      })()
   }
}

export const updateImage = async (id, image, dispatch) => {
   dispatch(imageStart())
   try {
      await userRequest.put(`/images/${id}`, image)
      dispatch(updateImageSuccess({ id, image }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(imageFailure(msg))
         return msg
      })()
   }
}

export const createImage = async (image, dispatch) => {
   dispatch(imageStart())
   try {
      const res = await userRequest.post(`/images`, image)
      dispatch(createImageSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(imageFailure(msg))
         return msg
      })()
   }
}

export const getEmails = async (dispatch) => {
   dispatch(emailStart())
   try {
      const res = await publicRequest.get("/emails")
      dispatch(getEmailSuccess(res.data))
   } catch (err) {
      ;(() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         return dispatch(emailFailure(msg))
      })()
   }
}

export const deleteEmail = async (id, dispatch) => {
   dispatch(emailStart())
   try {
      await userRequest.delete(`/emails/${id}`)
      dispatch(deleteEmailSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(emailFailure(msg))
         return msg
      })()
   }
}

export const getServiceRequest = async (dispatch) => {
   dispatch(serviceStart())
   try {
      const res = await userRequest.get("/service")
      dispatch(getServiceSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(serviceFailure(msg))
         return msg
      })()
   }
}

export const updateServiceRequest = async (id, order, dispatch) => {
   dispatch(serviceStart())
   try {
      await userRequest.put(`/service/${id}`, order)
      dispatch(updateServiceSuccess({ id, order }))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(serviceFailure(msg))
         return msg
      })()
   }
}

export const deleteServiceRequest = async (id, dispatch) => {
   dispatch(serviceStart())
   try {
      await userRequest.delete(`/service/${id}`)
      dispatch(deleteServiceSuccess(id))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(serviceFailure(msg))
         return msg
      })()
   }
}

export const createServiceRequest = async (pageContent, dispatch) => {
   dispatch(serviceStart())
   try {
      const res = await userRequest.post(`/service`, pageContent)
      dispatch(createServiceSuccess(res.data))
      return "success"
   } catch (err) {
      return (() => {
         const data = err?.response?.data
         const msg =
            typeof data === "string"
               ? data
               : data?.message ||
                 data?.error ||
                 data?.msg ||
                 data?.reason ||
                 err?.message ||
                 "Request failed"
         dispatch(serviceFailure(msg))
         return msg
      })()
   }
}
